var map = {
	"./_next.png": 1379,
	"./_prev.png": 1380,
	"./agpaginationbtn/btFirst.svg": 1381,
	"./agpaginationbtn/btLast.svg": 1382,
	"./agpaginationbtn/btNext.svg": 1383,
	"./agpaginationbtn/btPrevious.svg": 1384,
	"./bed-outline.png": 1385,
	"./c5.jpg": 1386,
	"./c6.jpg": 887,
	"./c7.jpg": 1387,
	"./c9.jpg": 1388,
	"./calendar-outline.png": 1389,
	"./calendar-outline1.png": 220,
	"./calendar.png": 886,
	"./caro3.jpg": 1390,
	"./caro7.jpg": 1391,
	"./caro8.jpg": 1392,
	"./check.png": 918,
	"./close_icon.png": 591,
	"./cloud-computing.png": 641,
	"./defaultRoom.png": 1393,
	"./defaultRoomImg.png": 1394,
	"./details.png": 1395,
	"./dropcloseicon.png": 891,
	"./dropcloseicon1.png": 1396,
	"./footerLogo.png": 878,
	"./guesthouse.jpg": 1397,
	"./happy.png": 924,
	"./hero-banner1.png": 972,
	"./highlights_tick.png": 557,
	"./homestay.png": 1398,
	"./hotel.png": 279,
	"./imageIcon.png": 1399,
	"./location.png": 1400,
	"./location1.png": 617,
	"./loginIcon.png": 637,
	"./next.png": 889,
	"./no-icon.png": 1401,
	"./no-icon1.png": 110,
	"./no-picture.jpg": 277,
	"./paymentIcons/payment1.png": 879,
	"./paymentIcons/payment2.png": 880,
	"./paymentIcons/payment3.png": 881,
	"./paymentIcons/payment4.png": 882,
	"./paymentIcons/payment5.png": 883,
	"./paymentIcons/payment6.png": 884,
	"./paymentIcons/payment7.png": 885,
	"./pencilColor.png": 896,
	"./people-outline.png": 1402,
	"./people-outline1.png": 892,
	"./pls.png": 677,
	"./prev.png": 888,
	"./profile-back.png": 622,
	"./qr-code.png": 1403,
	"./resetIcon.png": 922,
	"./searchicon.png": 1404,
	"./searchicon1.png": 642,
	"./shield.png": 919,
	"./smartphone1.png": 920,
	"./smartphone2.png": 921,
	"./stateLoaderImage.png": 371,
	"./staticmap.png": 902,
	"./staying-pic-arunachal.png": 1405,
	"./staying-pic-meghalaya.png": 1406,
	"./staying-pic-odisha.png": 1407,
	"./staying-pic-sikkim.png": 1408,
	"./staying-pic-tamil-nadu.png": 1409,
	"./staying-pic-west-bengal.png": 1410,
	"./stayingLogo.png": 596,
	"./stayingLogoNew.png": 973,
	"./stayingLogoWhite.png": 605,
	"./tickicon.png": 1411,
	"./toastify/bell.png": 925,
	"./toastify/error.png": 1412,
	"./toastify/errorimg.png": 926,
	"./toastify/info.png": 927,
	"./toastify/information.png": 928,
	"./toastify/success.png": 1413,
	"./toastify/successimg.png": 929,
	"./toastify/warning.png": 1414,
	"./toastify/warnningIcon.png": 930,
	"./trendingImg1.png": 970,
	"./trendingImg2.png": 1415,
	"./trendingImg3.png": 1416,
	"./trendingImg4.png": 1417,
	"./trendingImg5.png": 1418,
	"./trendingImg6.png": 1419,
	"./trendingImg7.png": 1420,
	"./unapprovedicon.png": 1421,
	"./updateIcon.png": 897,
	"./uploadFile.png": 1422,
	"./usericon.png": 604,
	"./vietnam.jpg": 1423,
	"./warning.png": 1424,
	"./zoom-in.png": 594,
	"./zoom-out.png": 595
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 270;